import React from 'react';

const TabComponentItem = props => {
  return <div {...props} />;
}

export default TabComponentItem